module.exports = __webpack_public_path__ + "static/media/LaBelleAurore-01.05aba3b9.svg";